import React from 'react';
import { Button, withStyles } from '@material-ui/core';
import PrintIcon from '@material-ui/icons/Print';

import axiosInstance, { addComma, EVENT_ID, EVENT_IMG, getUserID, WEB_API } from '../constatns';

import {
  EARLY_REGISTRATION_FEE,
  REGULAR_REGISTRATION_FEE,
  ONSITE_REGISTRATION_FEE,
  // RESIDENT_TABLE,
  OVERSEA_EARLY_REGISTRATION_FEE,
  OVERSEA_REGULAR_REGISTRATION_FEE,
  OVERSEA_ONSITE_REGISTRATION_FEE,
} from '../registration/RegistrationConstants';

const styles = (theme) => ({
  container: {
    border: '3px solid rgba(224, 224, 224, 1)',
    // backgroundColor: 'rgba(170,203,60,0.1)',
    padding: '50px 70px',
    textAlign: 'center',
    position: 'relative',
    // backgroundImage: `url('${EVENT_IMG}/ic/logo_receipt.png')`,
    // backgroundRepeat: 'no-repeat',
    // backgroundPosition: 'center center ',
    // backgroundSize: '50% 50%',
  },

  backgroundImageDiv: {
    // position: 'absolute',
    // top: 0,
    // left: 0,
    // right: 0,
    // backgroundImage: `url('${EVENT_IMG}/ic/logo_receipt.png')`,
    // backgroundRepeat: 'no-repeat',
    // backgroundPosition: 'center center ',
    // backgroundSize: '25% 25%',
    // opacith: 0.25,
  },
  outer: {
    display: 'flex',
    flexDirection: 'column',
  },
  inner: {
    display: 'flex',
    flexDirection: 'row',
    textAlign: 'left',
    padding: '0.3em 0',
    '& div:first-child': {
      width: '20%',
      fontWeight: 'bold',
    },
    '& div:last-child': {
      width: '80%',
    },
  },
  receiptContent: {
    fontWeight: 'bold',
    fontSize: '1.2em',
    '& p': {
      margin: '2em 0',
    },
  },
  outerPadding: {
    padding: '1em 0',
  },
  stampImage: {
    '@media print': { WebkitPrintColorAdjust: 'exact' },
    backgroundImage: `url(${EVENT_IMG}/mypage/encorestamp2.png)`,
    backgroundRepeat: 'no-repeat',
    height: '100px',
    backgroundPosition: 'right',
    backgroundPositionY: '-20px',
  },
});

class RegistrationReceipt extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      country: '',
      firstname: '',
      lastname: '',
      affiliation: '',
      amount: '',
      lang: '',
    };
  }

  componentDidMount() {
    axiosInstance.get(`${WEB_API}/user/info?eventId=${EVENT_ID}&userId=${getUserID()}`).then((res) => {
      if (res.data && res.data.Item) {
        if (res.data.Item.country) this.setState({ country: res.data.Item.country });
        if (res.data.Item.firstName) this.setState({ firstname: res.data.Item.firstName });
        if (res.data.Item.lastName) this.setState({ lastname: res.data.Item.lastName });
        if (res.data.Item.positionEn) this.setState({ affiliation: res.data.Item.positionEn });
        if (res.data.Item.lang) this.setState({ lang: res.data.Item.lang });
        // if (res.data.Item.amount) this.setState({ amount: res.data.Item.amount });
        if (res.data.Item.country) this.setState({ amount: this.currencyCalculate(res.data.Item) });
      }
    });
  }

  currencyCalculate = (userInfo) => {
    return addComma(this.calculateRegistrationFee(userInfo));
  };

  calculateRegistrationFee = (userInfo) => {
    const { country, regType, cate1, lang } = userInfo;
    let buff = 0;
    let refTable = 0;

    const tables = [
      EARLY_REGISTRATION_FEE,
      REGULAR_REGISTRATION_FEE,
      ONSITE_REGISTRATION_FEE,
      OVERSEA_EARLY_REGISTRATION_FEE,
      OVERSEA_REGULAR_REGISTRATION_FEE,
      OVERSEA_ONSITE_REGISTRATION_FEE,
    ];

    // 어느 요금표 배열 참고해야하는지
    switch (regType) {
      case 'R1':
        // 조기등록
        refTable = country.indexOf('Korea') !== -1 ? 0 : 3;
        break;
      case 'R2':
        // 사전등록
        refTable = country.indexOf('Korea') !== -1 ? 1 : 4;
        break;
      case 'R3':
        // 현장등록
        refTable = lang === 'kor' ? 2 : 5;
        break;
    }

    // 해당 요금표 배열에서 cate1에 해당되는 요금 select
    if (cate1 === '개원의') {
      // console.log(tables[refTable].findIndex((item) => item.category === '전문의'));
      buff = tables[refTable][tables[refTable].findIndex((item) => item.category === '전문의')].fee;
    } else {
      for (let i = 0; i < tables[refTable].length; i++) {
        if (cate1 === tables[refTable][i].category) {
          buff = tables[refTable][i].fee;
        }
        // console.log(tables[refTable][i]);
      }
    }
    // console.log(buff);
    return buff;
  };

  onPrint() {
    // const innerBody = document.body.innerHTML;
    window.onbeforeprint = () => {
      document.getElementById('buttons').style.visibility = 'hidden';
      //   document.body.innerHTML = document.getElementById('print').innerHTML;
    };
    window.onafterprint = () => {
      document.getElementById('buttons').style.visibility = 'visible';
      //   document.body.innerHTML = innerBody;
    };
    window.print();
  }

  onClose() {
    window.opener = 'Self';
    window.open('', '_parent', '');
    window.close(); // 일반적인 현재 창 닫기
    window.open('about:blank', '_self').self.close(); // IE에서 묻지 않고 창 닫기
  }

  render() {
    const { classes } = this.props;
    console.log(this.state.amount);
    console.log(this.state.lang);
    return (
      <>
        <div
          id="buttons"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            padding: '5px 1em',
          }}
        >
          <Button color="primary" variant="contained" disableElevation startIcon={<PrintIcon />} onClick={() => this.onPrint()}>
            Print
          </Button>
          <div style={{ width: '1em' }} />
          <Button color="primary" variant="contained" disableElevation onClick={() => this.onClose()}>
            Close
          </Button>
        </div>
        <div id="print">
          <div className={classes.container}>
            <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
              <img src={`${EVENT_IMG}/mypage/logo_receipt.png`} alt="" style={{ width: 200, height: 200, opacity: 0.25 }} />
            </div>
            <h1 style={{ borderBottom: '3px solid #555555', padding: 10 }}>RECEIPT</h1>
            <div className={`${classes.outer} ${classes.outerPadding}`}>
              <div className={classes.inner}>
                <div>Name</div>
                <div id={'registration-receipt-name'}>
                  &nbsp;&nbsp;{this.state.lastname ? `${this.state.lastname} ${this.state.firstname}` : ''}
                </div>
              </div>
              <div className={classes.inner}>
                <div>Affiliation</div>
                <div id={'registration-receipt-affiliation'}>&nbsp;&nbsp;{this.state.affiliation ? this.state.affiliation : ''}</div>
              </div>
              <div className={classes.inner}>
                <div>Amount</div>
                <div id={'registration-receipt-amount'}>
                  &nbsp;&nbsp;
                  {/* {this.state.country && this.state.country.indexOf('Korea') !== -1 ? 'KRW ' : 'USD '} */}
                  {(this.state.country && this.state.country.indexOf('Korea') !== -1) ||
                  (this.state.lang && this.state.lang.indexOf('kor') !== -1)
                    ? 'KRW '
                    : 'USD'}
                  {this.state.amount ? (this.state.amount !== 'Free' ? addComma(this.state.amount) : 0) : ''}
                </div>
              </div>
            </div>
            <div className={`${classes.outerPadding} ${classes.receiptContent}`}>
              We received above amount as registration fee for
              <br />
              PRS KOREA 2022.
              <p>11(Fri) ~ 13(Sun) November, 2022</p>
              {/* <div className={classes.stampImage}>
                <div style={{ padding: '20px', fontSize: '1.17em' }}>Korean Society of Plastic and Reconstructive Surgeons</div>
              </div> */}
            </div>
            <div className={classes.outerPadding}>
              <div style={{ position: 'relative', width: '100%', height: '115px' }}>
                <div
                  style={{
                    padding: '20px',
                    fontSize: '1.2em',
                    fontWeight: 'bold',
                    position: 'absolute',
                    width: '100%',
                    left: '50%',
                    top: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 999,
                  }}
                >
                  Korean Society of Plastic and Reconstructive Surgeons
                </div>
                <img
                  src={`${EVENT_IMG}/mypage/encorestamp2.png`}
                  style={{
                    position: 'absolute',
                    top: '50%',
                    transform: 'translateY(-60%)',
                    right: 0,
                    zIndex: 22,
                  }}
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withStyles(styles)(RegistrationReceipt);
